var isSubmit = false;

$(document).ready(function() {
    isSubmit = false;
});

$(document).on("submit", "form", function(){
    isSubmit = true;
});

$(window).on('beforeunload', function () {
    if (!isSubmit && $("[unsavedInput='true']").length !== 0) {
        return 'unsaved';
    }
});